import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggler from '@fiverr/ui_toggle';
import { TOGGLE_DELAY } from '../../utils';

class MenuItemDefaultToggler extends Component {

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleMouseOver = this.handleMouseOver.bind(this);
    }

    handleClick() {
        return true;
    }

    handleMouseEnter() {
        return true;
    }

    handleMouseLeave() {
        return true;
    }

    handleMouseOver() {
        return true;
    }

    render() {
        return (
            <Toggler {...this.props}>
                {
                    ({ isOpen, toggle, open, close, preventCloseAction }) => (
                        this.props.children(
                            isOpen,
                            preventCloseAction,
                            (e) => this.handleClick(e, toggle),
                            (e) => this.handleMouseLeave(e, close),
                            (e) => this.handleMouseOver(e, open)
                        )
                    )
                }
            </Toggler>
        );
    }
}

MenuItemDefaultToggler.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};

MenuItemDefaultToggler.defaultProps = {
    children: null
};

class MenuItemMDToggler extends MenuItemDefaultToggler {
    constructor(){
        super();
        this.open = null;
        this.close = null;
    }
    handleMouseEnter(e, open) {
        e.preventDefault();
        clearTimeout(this.close);
        this.open = setTimeout(() => { open(e); }, TOGGLE_DELAY.LONG);
    }

    handleMouseLeave(e, close) {
        e.preventDefault();
        clearTimeout(this.open);
        this.close = setTimeout(() => { close(e); }, TOGGLE_DELAY.LONG);
    }

    handleMouseOver(e, open) {
        e.preventDefault();
        clearTimeout(this.close);
        this.open = setTimeout(() => { open(e); }, TOGGLE_DELAY.LONG);
    }
}

const MenuItemToggler = ({ children, ...props }) => (
    <MenuItemMDToggler {...props}>{ children }</MenuItemMDToggler>
);

MenuItemToggler.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};

MenuItemToggler.defaultProps = {
    children: null
};

export default MenuItemToggler;
